export function formatIsoDate (date, options) {
  if (!options) {
    options = {
      timeZone: 'UTC',
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    }
  }
  if (!options.timeZone) {
    options.timeZone = 'UTC'
  }
  return new Date(date).toLocaleDateString('en-US', options)
}

export function cleanInvisibleChars (text) {
  if (!text) return text
  // Remove invisible Unicode characters that can break CSV parsing
  // This includes zero-width spaces, marks, and other control characters
  // but preserves intentional newlines and tabs
  return String(text)
    .replace(/[\u200B-\u200D\uFEFF]/g, '') // Zero-width spaces, joiners, non-joiners, BOM
    .replace(/[\u200E-\u200F]/g, '') // Left-to-right and right-to-left marks
    .replace(/[\u202A-\u202E]/g, '') // Directional formatting characters
    .replace(/[\u2060-\u2064]/g, '') // Word joiner and other invisible characters
    .replace(/[\u2066-\u2069]/g, '') // Left-to-right isolate, etc.
    .trim()
}

export function escapeCsvField (text) {
  if (!text) return ''
  // Clean invisible characters first
  let cleaned = cleanInvisibleChars(text)
  // Escape double quotes by doubling them (CSV standard)
  cleaned = cleaned.replace(/"/g, '""')
  return cleaned
}
